import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Link, useLocation } from 'react-router-dom';
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { useIsAuthenticated } from '@azure/msal-react';
import dateFormat from 'dateformat';
import htmr from 'htmr';
import { useTranslation } from 'react-i18next';
import style from './recommended.module.scss';
import { removeStyleAttribute } from '../../../../utils/helpers';
import colors from '../../../../scss/colors';

const Header = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap'
});

const SubHeader = styled('div')({
  display: 'flex',
  marginBottom: '10px',
  span: {
    display: 'inline-flex',
    justifyContent: 'center',
    fontWeight: '300',
    fontSize: '12px',
    lineHeight: '14px',
    marginRight: '15px',
    color: colors.MEDIUM_GREY,
    ':last-of-type': {
      marginRight: 0
    },
    svg: {
      fontSize: '14px'
    }
  }
});

const JobTitle = styled('h5')({
  fontSize: '14px',
  lineHeight: '18px',
  color: colors.BLACK_TXT
});

const JobDescription = styled('div')({
  display: '-webkit-box',
  '-webkit-line-clamp': '3',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
  height: '100%',
  marginBottom: '10px',
  fontSize: '12px',
  lineHeight: '14px'
});

const StyledLink = styled(Link)({
  fontSize: '14px',
  lineHeight: '18px',
  textDecoration: 'none',
  fontWeight: '600',
  color: colors.PRIMARY_BLUE
});

function RecommendedJobCard(props) {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const { job, borderColor = colors.NAVY_BLUE } = props;
  const { t } = useTranslation();
  if (!job)
    return (
      <>
        {t('dashboard.jobs.loading')} <br />
      </>
    );

  const chooseMaxWidthCase = () => {
    const queryString = location.search;

    if (queryString.includes('tab=applied')) return '318px';
    if (queryString.includes('action=apply')) return '100%';
    return '360px';
  };

  const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 10px',
    border: `1px solid ${borderColor}`,
    borderRadius: '5px',
    height: '151px',
    minWidth: '318px',
    maxWidth: chooseMaxWidthCase()
  });

  return (
    <Container className={props.className}>
      <Header>
        <JobTitle>
          <strong>{job.JobTitle}</strong>
        </JobTitle>
        <Box
          sx={{
            marginLeft: 'auto',
            whiteSpace: 'nowrap',
            height: 'fit-content',
            lineHeight: '18px',
            span: {
              fontSize: '12px',
              textAlign: 'center',
              color: colors.MEDIUM_GREY
            }
          }}
        >
          {job.IsApplied && <div className={style.appliedTag}>{t('dashboard.jobs.applied')}</div>}
          <span data-testid="publish">{dateFormat(job.PublishedDate, 'dd mmm yyyy')}</span>
        </Box>
        {/* <div className={`${style.bookmark} col-1 text-end`}>
          <BookmarkBorderOutlinedIcon />
        </div> */}
      </Header>
      <SubHeader>
        <span>
          <LocationOnOutlined /> {job.Location}
        </span>
        <span>
          <DescriptionOutlinedIcon />
          {job.JobType}
        </span>
      </SubHeader>
      <JobDescription>{htmr(removeStyleAttribute(job.JobDescription || ''))}</JobDescription>
      <StyledLink to={`${isAuthenticated ? '/dashboard' : ''}/jobs/${job.Id}`}>
        {t('common.general.readmore')}
      </StyledLink>
    </Container>
  );
}

export default RecommendedJobCard;
